import { Interpolation, Theme } from '@emotion/react'
import facepaint from 'facepaint'
import { FunctionComponent, MouseEvent, ReactNode } from 'react'
import { useDispatch, usePlayerState } from '../contexts/playerState'
import { mqs } from '../utils/theme'

const PlayerInfoDefaultProps = {
  content: '',
}

interface PlayerInfoProps {
  content?: ReactNode
}

const PlayerInfo: FunctionComponent<PlayerInfoProps> = ({ content }) => {
  const { isInfoOpen } = usePlayerState()

  const dispatchPlayerState = useDispatch()

  const onClick = (e: MouseEvent) => {
    e.stopPropagation()
    dispatchPlayerState({ type: isInfoOpen ? 'closeInfo' : 'openInfo' })
  }

  return (
    <div className="mcls-player-info-button-wrapper">
      <button
        role="button"
        aria-label="Event info"
        title="Event info"
        onClick={onClick}
        css={buttonStyle}
        className="mcls-player-info-button"
      >
        {isInfoOpen ? (
          <span className="vjs-icon-cancel" />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 417 417"
            height={24}
            fill="#FFF"
          >
            <path d="M356 61A208 208 0 1061 356 208 208 0 00356 61zM238 341c0 3-3 6-6 6h-47c-3 0-6-3-6-6V168c0-3 3-6 6-6h47c3 0 6 3 6 6v173zm-30-203a34 34 0 111-68 34 34 0 01-1 68z" />
          </svg>
        )}
      </button>
      <div
        data-open={isInfoOpen}
        css={infoBoxStyle(!!isInfoOpen)}
        style={{ opacity: isInfoOpen ? 1 : 0 }}
        className="mcls-player-info-overlay-wrapper"
      >
        {content}
      </div>
    </div>
  )
}

PlayerInfo.defaultProps = PlayerInfoDefaultProps

export default PlayerInfo

const mq = facepaint([mqs.s, mqs.m, mqs.l, mqs.xl])

const zIndex = 20

const buttonStyle: Interpolation<Theme> = {
  position: 'absolute',
  top: 0,
  right: 0,
  padding: '16px',
  outline: 'none',
  cursor: 'pointer',
  width: '56px',
  zIndex: zIndex + 2,
  span: {
    fontSize: '28px!important',
    marginTop: '-2px',
    marginLeft: '-2px',
    display: 'block',
  },
}

const infoBoxStyle = (isVisible: boolean): Interpolation<Theme> =>
  mq({
    background: '#000',
    display: 'flex',
    fontFamily: "'Rubik', sans-serif",
    position: 'absolute',
    minHeight: '100%',
    overflow: 'auto',
    textAlign: 'left',
    width: '100%',
    zIndex: isVisible ? zIndex + 1 : 0,
    transition: 'opacity .3s',
  })
